import React, { useState, useEffect } from 'react'
import { trackPromise } from 'react-promise-tracker'

import { GetAssetComparisonChart } from 'store/ChartApiClient'

import { StyleSeries, StyleDrilldownDataPoints } from 'highcharts/HighchartsStyleHelper'
import {
    SetupDefaultOptions,
    FULL_HEIGHT_NO_INPUT_ROW,
    DisableFirstSeries,
} from 'highcharts/HighchartsHelper'
import LoadingWrapper from 'components/LoadingWrapper'
import HighchartsWrapper from '../../../../../../highcharts/HighchartsWrapper'
import { DarkBackgroundColor } from '../../../../../../highcharts/HighchartsStyleHelper'

const AssetComparisonStep = ({ id }) => {
    const PromiseArea = 'graph-assets-comparison'
    const [options, setOptions] = useState({
        chart: {
            events: {
                load: function (e) {
                    var chart = this
                    chart.showLoading()
                },
                drilldown: function (e) {
                    var chart = this
                    var { seriesOptions } = e
                    chart.options.lang.drillUpText = '◁ Back to {series.name}'
                    if (seriesOptions && seriesOptions.id === 'Assets') {
                        const { data } = seriesOptions
                        if (data && data.length > 0) {
                            //convert drilldown data into multi series graph
                            chart.options.lang.drillUpText = 'Consolidate Assets'
                            StyleDrilldownDataPoints({ data })
                            DisableFirstSeries(data)

                            data.forEach((_) => {
                                let series = {
                                    ..._,
                                    data: [_],
                                    dataLabels: { enabled: false },
                                    legendIndex: 0,
                                }
                                chart.addSingleSeriesAsDrilldown(e.point, series)
                            })
                            chart.applyDrilldown()
                        }
                    }
                },
                drillup: function (e) {
                    var chart = this
                    chart.options.lang.drillUpText = '◁ Back to {series.name}'
                },
            },
        },
    })

    const [error, setError] = useState(null)

    useEffect(() => {
        const StyleGraph = (opts) => {
            opts = SetupDefaultOptions(opts, FULL_HEIGHT_NO_INPUT_ROW, false)
            if (opts.drilldown && opts.drilldown.series) {
                opts.series = opts.series.map((data) => StyleSeries(data))
                opts.drilldown.series[1] = StyleDrilldownDataPoints(opts.drilldown.series[1])
                opts.drilldown = {
                    ...opts.drilldown,
                    activeAxisLabelStyle: {
                        textDecoration: 'none',
                        color: 'white',
                    },
                }
            }
            if (opts.series) {
                if (opts.series.length > 1) {
                    opts.series[1].visible = false
                }

                // set color
                if (
                    opts.series &&
                    opts.series[0] &&
                    opts.series[0].data &&
                    opts.series[0].data[0]
                ) {
                    opts.series[0].data[0].dataLabels = {
                        color: DarkBackgroundColor,
                    }
                }
            }

            if (opts.drilldown) {
                if (opts.drilldown.series[0]) {
                    opts.drilldown.series[0].dataLabels = { enabled: false }
                }
                if (opts.drilldown.series[1]) {
                    opts.drilldown.series[1].dataLabels = { enabled: false }
                }
            }

            opts = {
                ...opts,
                plotOptions: {
                    ...opts.plotOptions,
                    column: {
                        ...opts.plotOptions.column,
                        stacking: 'normal',
                        dataLabels: {
                            ...opts.plotOptions.column.dataLabels,
                            enabled: true,
                        },
                    },
                    series: {
                        events: {
                            afterAnimate: (e) => {
                                //drilldown on consolidate assets if present
                                //cannot event earlier as graph is not fully rendered
                                const {
                                    target: { chart },
                                } = e
                                if (chart && chart.series && chart.series.length === 3) {
                                    let consolidated = chart.series[2]
                                    if (
                                        consolidated &&
                                        consolidated.data &&
                                        consolidated.data[1] &&
                                        !chart.userOptions.consolidateLoaded
                                    ) {
                                        chart.userOptions.consolidateLoaded = true
                                        consolidated.data[1].doDrilldown()
                                        chart.hideLoading()
                                    }
                                }
                            },
                        },
                    },
                },
            }

            setOptions(opts)
        }

        trackPromise(
            GetAssetComparisonChart(id)
                .then((resp) => {
                    const { data } = resp
                    StyleGraph(data)
                })
                .catch((err) => {
                    setError(err)
                })
                .finally(() => {}),
            PromiseArea
        )
    }, [id])

    if (error) {
        return <p>Something went wrong, try again later</p>
    }

    return (
        <LoadingWrapper area={PromiseArea}>
            <HighchartsWrapper options={options} printHeightPx={500} />
        </LoadingWrapper>
    )
}

export default AssetComparisonStep
